import Experience from "./Experience";

export default class ListCount {
    constructor(container, value) {
        this.experience = new Experience()
        this.container = container
        this.value = value
        this.container.style.display = 'flex'
        // 
        console.log('create counter');


        this.counter = document.createElement('div')
        this.counter.classList.add('counter')
        this.counter.style.overflow = `hidden`
        // 
        for (let i = 0; i < 3; i++) {
            const column = document.createElement('div'); // Nouvelle colonne à chaque itération
            column.classList.add('col')
            column.innerHTML = `
                <p>0</p>
                <p>1</p>
                <p>2</p>
                <p>3</p>
                <p>4</p>
                <p>5</p>
                <p>6</p>
                <p>7</p>
                <p>8</p>
                <p>9</p>
            `;
            column.style.margin = '0 1px'; // Ajoute un espace entre les colonnes

            this.counter.appendChild(column); // Ajoute la colonne au conteneur
        }
        // 
        this.textContent = document.createElement('div')
        this.textContent.classList.add('text')
        this.textContent.style.marginLeft = '0rem'
        this.textContent.innerHTML = `expert${this.value > 1 ? 's' : 's'} found`
        this.container.appendChild(this.counter)
        this.container.appendChild(this.textContent)

    }

    setTo(value) {
        const valueSize = value.toString().length
        this.textContent.style.marginLeft = `${-(3 - valueSize) * 20}rem`
        // 
        let strValue = value.toString().split('');
        while (strValue.length < 3) {
            strValue.push('0');
        }
        const cols = document.querySelectorAll('.mapContainer .mapDataContainer .listCount .counter .col')
        cols.forEach((col, i) => {
            if ((valueSize === 1 && (i === 1 || i === 2)) || (valueSize === 2 && i === 2)) {
                col.style.transform = 'translateY(100%)';
            } else {
                col.style.transform = `translateY(${strValue[i] * -100}%)`;
            }
        });




    }

}